import React, { useEffect, useState } from "react";
import axios from "axios";
import { LogOut, Loader2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import API from "../API/axios";

const LogoutPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("Logging you out...");

  useEffect(() => {
    const logout = async () => {
      try {
        const refreshToken = localStorage.getItem("sellerRefreshToken");

        if (!refreshToken) {
          throw new Error("No refresh token found");
        }

        await API.post("/auth/logout", {
          token: refreshToken,
        });

        setMessage("Logout successful");

        // clear tokens
        localStorage.removeItem("sellerAccessToken");
        localStorage.removeItem("sellerRefreshToken");
        localStorage.removeItem("sellerProfile");
        localStorage.removeItem("sellerEmail");
        localStorage.removeItem("sellerName");
        localStorage.removeItem("sellerGstin");
        localStorage.removeItem("sellerPanNumber");
        localStorage.removeItem("sellerBusinessAddress");

        setTimeout(() => {
          navigate("/login");
        }, 1500);
      } catch (error) {
        console.error(error);
        setMessage("Logout failed. Redirecting...");

        setTimeout(() => {
          navigate("/login");
        }, 1500);
      } finally {
        setLoading(false);
      }
    };

    logout();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="bg-white p-10 rounded-2xl shadow-lg text-center max-w-sm w-full">
        <div className="flex justify-center mb-6">
          {loading ? (
            <Loader2 className="animate-spin text-primary" size={40} />
          ) : (
            <LogOut className="text-green-500" size={40} />
          )}
        </div>

        <h2 className="text-xl font-bold text-slate-900 mb-2">Logout</h2>

        <p className="text-slate-500 text-sm">{message}</p>
      </div>
    </div>
  );
};

export default LogoutPage;
